(function () {
    'use strict';

    angular
        .module('app')
        .factory('authorsSearchService', authorsSearchService);

    authorsSearchService.$inject = ['$http', '$q'];

    function authorsSearchService($http, $q) {
        var service = {
            getAuthors: getAuthors
        };

        return service;

        function getAuthors() {
            var deferred = $q.defer();

            $http.get('/api/emr/authorsSearch/results', { params: { } })
                .then(function (results) {
                    deferred.resolve(results.data);
                }).catch();

            return deferred.promise;
        }

    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/factories/_authorsSearchService.js
// module id = 13
// module chunks = 0